<template lang="pug">
  .student-mini-card.is-flex.has-flex-center-items(:class="size")
    user-picture(:user="student")
    .min-width-fit-content
      | {{ student.first_name || 'Student '+(index+1) }}&nbsp;{{ student.last_name }}
      template(v-if="student.city")
        p.has-text-grey.is-size-7.is-flex.has-flex-center-items.has-justify-end
          i.mdi.mdi-map.mr-1.is-size-7
          |  {{ student.city }}



</template>

<script>
import userPicture from "@/components/UserPictureUI";
import { mapGetters } from "vuex";

export default {
  name: "student-mini-card",
  props: ["student", "index", "size"],
  components: {
    userPicture
  },
  computed: {
    ...mapGetters(["apiUrl"])
  }
};
</script>


<style lang="scss">
@import "colors";

$figureSize: 36px;
$imgSize: 32px;

$figureSizeXl: 50px;
$imgSizeXl: 46px;

.min-width-fit-content {
  min-width: fit-content;
}

.student-mini-card {
  figure.avatar {
    width: $figureSize;
    height: $figureSize;
    vertical-align: middle;
    display: inline-block;
    margin-right: 8px;
    img {
      width: $figureSize;
      height: $figureSize;
      padding: 2px;
    }
  }
  .is-large {
    figure.avatar {
      width: $figureSizeXl;
      height: $figureSizeXl;
      img {
        width: $figureSizeXl;
        height: $figureSizeXl;
      }
    }
    .letter-avatar {
      line-height: $figureSizeXl;
      span {
        line-height: $imgSizeXl;
        height: $imgSizeXl;
        width: $imgSizeXl;
      }
    }
  }
}
</style>
